import { mq } from '@design/query';
import styled from 'styled-components';

const paddingCss = ({ $ratio = 1.618 }: { $ratio?: number | number[] }) => {
  if (typeof $ratio === 'number') {
    return { paddingTop: `${100 / $ratio}%` };
  } else {
    return mq({
      paddingTop: $ratio.map((r) => `${100 / r}%`),
    });
  }
};

const SimpleAspectBox = styled.div<{ $ratio: number | number[] }>`
  position: relative;
  padding: 0;
  height: 0;
  overflow: hidden;
  ${({ $ratio }) => paddingCss({ $ratio })}

  > span {
    position: absolute !important;
  }

  & > * {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    object-fit: cover;
  }
`;

export default SimpleAspectBox;
